import { Asset } from "tweenly/dist/fetchAsset"
import { tickerTextRequester } from "tweenly"

export abstract class BaseTicker {
    protected timeline: GSAPTimeline
    protected objectId: string

    protected currentJoinedTexts: string | null

    protected pendingRef: { value: boolean }
    protected latestRef: { value: string | null }
    protected requestTexts: () => Promise<void>

    protected constructor(
        timeline: GSAPTimeline,
        objectId: string,
        joinedTexts: string | null,
        childTexts: string[],
        assets: Asset[]
    ) {
        this.timeline = timeline
        this.objectId = objectId
        this.currentJoinedTexts = joinedTexts

        const requester = tickerTextRequester(childTexts, assets)
        this.pendingRef = requester.pendingRef
        this.latestRef = requester.latestRef
        this.requestTexts = requester.requestTexts
    }

    start() {
        this.intro()
    }

    protected handleRepeat(repeat: () => void) {
        if (this.latestRef.value && this.latestRef.value !== this.currentJoinedTexts) {
            const newVal = this.latestRef.value
            this.latestRef.value = null
            this.outro(newVal)
            return
        }

        if (this.pendingRef.value) {
            repeat()
            return
        }

        this.requestTexts()
        repeat()
    }

    protected abstract intro(): void
    protected abstract outro(newTexts?: string): void
}
